module.exports = __webpack_public_path__ + "static/img/game-logo-world.abbfc89.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-world.png
// module id = VoKM
// module chunks = 0 1 2 3 4 5 6